if (document.getElementById('vue-residences')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: ['[[', ']]'],
		mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin],
		el: '#vue-residences',
		data: {
			residences: [],
			articles: []
		},
		computed: {
			idfResidences() {
				return this.residences.filter((el) => el.idf && !el.is_short_lived);
			},
			otherResidences() {
				return this.residences.filter((el) => !el.idf && !el.is_short_lived);
			},
			shortlivedResidences() {
				return this.residences.filter((el) => el.is_short_lived);
			}
		},
		mounted() {
			this.getResidences();
			if (window.site_id === 2) {
				this.selectedCategory = 4;
			}
			this.getArticles();
			this.eventHub.$on('google-maps:loaded', () => {
				let hash = getUrlHash();
				if (hash !== '') {
					scroll('scroll-to-' + hash);
				}
			});
		},
		methods: {
			getResidences() {
				this.get('residences', { site: window.site_id }, false)
					.then((response) => {
						this.residences = response.data.results;
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			getArticles() {
				this.get('articles', { category__sites: window.site_id, block_display: true, category: this.selectedCategory }, false)
					.then((response) => {
						this.articles = response.data.results;
						this.$nextTick(() => {
							initCarouselNews();
						});
					})
					.catch((error) => {
						// console.log(error);
					});
			}
		}
	});
}
